"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Board = void 0;
require("reflect-metadata");
const class_transformer_1 = require("class-transformer");
const nanoid_1 = require("nanoid");
const rxjs_1 = require("rxjs");
const CannotPlayActionError_1 = require("../error/board/CannotPlayActionError");
const BoardEvent_1 = require("../messaging/event/BoardEvent");
const Bet_1 = require("./Bet");
const Blind_1 = require("./Blind");
const Deck_1 = require("./Deck");
const Pot_1 = require("./Pot");
const BoardState_1 = require("./states/BoardState");
const BoardStateAction_1 = require("./states/BoardStateAction");
const BoardStateReducer_1 = require("./states/BoardStateReducer");
class Board {
    constructor(blinds, id = nanoid_1.nanoid(), subscriber) {
        this.id = id;
        this.communityCards = [];
        this.bets = [];
        this.sidePots = [];
        this.state = BoardState_1.BoardStates.PreDeal;
        this.event$ = new rxjs_1.Subject();
        this.blinds = blinds;
        if (subscriber) {
            this.event$.subscribe(subscriber);
        }
        this.setupNewHand(this.blinds);
    }
    setupNewHand(blinds) {
        this.bets = [];
        this.deck = new Deck_1.Deck();
        this.deck.shuffleSattolo();
        this.pot = new Pot_1.Pot(0, [], Pot_1.PotKind.MAIN);
        this.sidePots = [];
        this.blinds = blinds;
        this.communityCards = [];
        this.state = BoardState_1.BoardStates.PreDeal;
        this.event$.next(BoardEvent_1.BoardEvents.newHandEvent(this));
    }
    setPlayers(players) {
        this.pot.players = players;
    }
    canSeatNewPlayers() {
        return BoardState_1.BoardStates.isPreDeal(this.state);
    }
    nextAction() {
        if (BoardState_1.BoardStates.isPreDeal(this.state)) {
            this.state = BoardStateReducer_1.BoardReducer(BoardStateAction_1.BoardActions.DealCards, this.state);
        }
        else if (BoardState_1.BoardStates.isDeal(this.state)) {
            this.state = BoardStateReducer_1.BoardReducer(BoardStateAction_1.BoardActions.DealFlop, this.state);
            this.dealFlop();
        }
        else if (BoardState_1.BoardStates.isFlop(this.state)) {
            this.state = BoardStateReducer_1.BoardReducer(BoardStateAction_1.BoardActions.DealTurn, this.state);
            this.dealTurn();
        }
        else if (BoardState_1.BoardStates.isTurn(this.state)) {
            this.state = BoardStateReducer_1.BoardReducer(BoardStateAction_1.BoardActions.DealRiver, this.state);
            this.dealRiver();
        }
        else if (BoardState_1.BoardStates.isRiver(this.state)) {
            this.state = BoardStateReducer_1.BoardReducer(BoardStateAction_1.BoardActions.EvalShowdown, this.state);
        }
        else if (BoardState_1.BoardStates.isShowdown(this.state)) {
            this.state = BoardStateReducer_1.BoardReducer(BoardStateAction_1.BoardActions.ResetBoard, this.state);
            this.setupNewHand(this.blinds);
        }
    }
    dealHoleCards() {
        if (BoardState_1.BoardStates.isDeal(this.state)) {
            this.event$.next(BoardEvent_1.BoardEvents.dealtHoleCardsEvent(this));
            return this.deck.cards.splice(0, 2);
        }
        throw new CannotPlayActionError_1.CannotPlayActionError(BoardStateAction_1.BoardActions.DealCards, this.state.description);
    }
    dealFlop() {
        if (BoardState_1.BoardStates.isFlop(this.state)) {
            this.deck.burnOne();
            const flop = this.deck.cards.splice(0, 3);
            this.communityCards = this.communityCards.concat(flop);
            this.event$.next(BoardEvent_1.BoardEvents.dealtFlop(this));
            return flop;
        }
        throw new CannotPlayActionError_1.CannotPlayActionError(BoardStateAction_1.BoardActions.DealFlop, this.state.description);
    }
    dealTurn() {
        if (BoardState_1.BoardStates.isTurn(this.state)) {
            this.deck.burnOne();
            const turn = this.deck.cards.splice(0, 1)[0];
            this.communityCards.push(turn);
            this.event$.next(BoardEvent_1.BoardEvents.dealtTurn(this));
            return turn;
        }
        throw new CannotPlayActionError_1.CannotPlayActionError(BoardStateAction_1.BoardActions.DealTurn, this.state.description);
    }
    dealRiver() {
        if (BoardState_1.BoardStates.isRiver(this.state)) {
            this.deck.burnOne();
            const river = this.deck.cards.splice(0, 1)[0];
            this.communityCards.push(river);
            this.event$.next(BoardEvent_1.BoardEvents.dealtRiver(this));
            return river;
        }
        throw new CannotPlayActionError_1.CannotPlayActionError(BoardStateAction_1.BoardActions.DealRiver, this.state.description);
    }
    evalShowdown() {
        if (BoardState_1.BoardStates.isShowdown(this.state)) {
            this.event$.next(BoardEvent_1.BoardEvents.showdown(this));
            return;
        }
        throw new CannotPlayActionError_1.CannotPlayActionError(BoardStateAction_1.BoardActions.EvalShowdown, this.state.description);
    }
    isPreDeal() {
        return BoardState_1.BoardStates.isPreDeal(this.state);
    }
    isDeal() {
        return BoardState_1.BoardStates.isDeal(this.state);
    }
    isFlop() {
        return BoardState_1.BoardStates.isFlop(this.state);
    }
    isTurn() {
        return BoardState_1.BoardStates.isTurn(this.state);
    }
    isRiver() {
        return BoardState_1.BoardStates.isRiver(this.state);
    }
    isShowdown() {
        return BoardState_1.BoardStates.isShowdown(this.state);
    }
    smallestBetWithoutBB() {
        return this.bets
            .filter((b) => b !== null && typeof b !== 'undefined' && b.kind !== 'bigblind')
            .reduce((accBet, bet) => {
            if (bet.amount !== 0) {
                return accBet < bet.amount ? accBet : bet.amount;
            }
            return accBet;
        }, Number.MAX_VALUE);
    }
    smallestBetWithoutSB() {
        return this.bets
            .filter((b) => b !== null && typeof b !== 'undefined' && b.kind !== 'smallblind')
            .reduce((accBet, bet) => {
            if (bet.amount !== 0) {
                return accBet < bet.amount ? accBet : bet.amount;
            }
            return accBet;
        }, Number.MAX_VALUE);
    }
    smallestBetWithoutSBandBB() {
        return this.bets
            .filter((b) => b !== null &&
            typeof b !== 'undefined' &&
            b.kind !== 'smallblind' &&
            b.kind !== 'bigblind')
            .reduce((accBet, bet) => {
            if (bet.amount !== 0) {
                return accBet < bet.amount ? accBet : bet.amount;
            }
            return accBet;
        }, Number.MAX_VALUE);
    }
    smallestBet() {
        return this.bets
            .filter((b) => b !== null && typeof b !== 'undefined')
            .reduce((accBet, bet) => {
            if (bet.amount !== 0) {
                return accBet < bet.amount ? accBet : bet.amount;
            }
            return accBet;
        }, Number.MAX_VALUE);
    }
    biggestBet() {
        return this.bets
            .filter((b) => b !== null && typeof b !== 'undefined')
            .reduce((accBet, bet) => {
            return accBet > bet.amount ? accBet : bet.amount;
        }, 0);
    }
    secondBiggestBet() {
        let biggest = this.biggestBet();
        let nextbiggest = 0;
        for (var i = 0; i < this.bets.length; i++) {
            if (this.bets[i] && this.bets[i].amount > biggest) {
                nextbiggest = biggest;
                biggest = this.bets[i].amount;
            }
            else if (this.bets[i] &&
                this.bets[i].amount > nextbiggest &&
                this.bets[i].amount !== biggest) {
                nextbiggest = this.bets[i].amount;
            }
        }
        return nextbiggest;
    }
    lastBet() {
        let lastBetAmount = this.bets
            .filter((b) => b !== null && typeof b !== 'undefined')
            .filter((b) => b.kind === Bet_1.BetKind.BET ||
            b.kind === Bet_1.BetKind.RAISE ||
            b.kind === Bet_1.BetKind.BIGBLIND)
            .reduce((accBet, bet) => {
            return accBet > bet.amount ? accBet : bet.amount;
        }, 0);
        if (lastBetAmount === 0 && this.isDeal()) {
            lastBetAmount = this.blinds.big;
        }
        return lastBetAmount;
    }
    doCheckForPlayerAt(seatId) {
        if (!this.bets[seatId]) {
            this.bets[seatId] = new Bet_1.Bet(0, Bet_1.BetKind.CHECK);
        }
        else {
            this.bets[seatId].kind = Bet_1.BetKind.CHECK;
        }
    }
    doCallForPlayerAt(seatId) {
        this.bets[seatId] = new Bet_1.Bet(this.biggestBet(), Bet_1.BetKind.CALL);
    }
    doBetForPlayerAt(seatId, bet) {
        this.bets[seatId] = bet;
    }
    adjustBetForPlayerAt(seatId, amount) {
        if (this.bets[seatId]) {
            this.bets[seatId].amount -= amount;
            if (this.bets[seatId].amount <= 0) {
                this.bets[seatId] = undefined;
            }
        }
    }
    adjustBetForBigBlind(seatId, amount) {
        if (this.bets[seatId]) {
            this.bets[seatId].amount = amount;
        }
    }
    addPlayerBettingSeatAt(seatId) {
        let bet = undefined;
        if (this.bets[seatId] !== null) {
            bet = this.bets[seatId];
            delete this.bets[seatId];
        }
        this.bets[seatId + 1] = bet;
    }
    getBetForPlayerAt(seatId) {
        return this.bets[seatId];
    }
    playerHasBetAt(seatId) {
        if (this.bets[seatId]) {
            return true;
        }
        return false;
    }
    hasBets() {
        return this.bets.length > 0;
    }
    hasNonZeroBets() {
        const bets = this.bets
            .filter((b) => b !== null && typeof b !== 'undefined')
            .reduce((acc, bet) => {
            acc += bet.amount;
            return acc;
        }, 0);
        return bets > 0;
    }
    hasBetsNoChecks() {
        return (this.bets
            .filter((b) => b !== null && typeof b !== 'undefined')
            .filter((b) => b.kind !== Bet_1.BetKind.CHECK).length > 0);
    }
    addBetsToPot(pot = new Pot_1.Pot(0, [], Pot_1.PotKind.MAIN)) {
        pot.amount += this.getBetsTotal();
        this.clearBets();
        if (pot.players.length === 0) {
            pot.players = this.pot.players;
        }
        this.addPot(pot);
        this.event$.next(BoardEvent_1.BoardEvents.betsToPot(this));
    }
    addBetsToMainPot(pot = new Pot_1.Pot(0, [], Pot_1.PotKind.MAIN)) {
        pot.amount += this.getBetsTotal();
        this.clearBets();
        if (pot.players.length === 0) {
            pot.players = this.pot.players;
        }
        this.addMainPot(pot);
        this.event$.next(BoardEvent_1.BoardEvents.betsToPot(this));
    }
    addMainPot(pot) {
        const exists = this.getAllPots().find((existingPot) => JSON.stringify(existingPot.getPlayerIds()) ===
            JSON.stringify(pot.getPlayerIds()));
        if (pot.kind === Pot_1.PotKind.MAIN) {
            this.pot.amount += pot.amount;
        }
        else {
            if (exists) {
                exists.amount += pot.amount;
            }
            else {
                pot.kind = Pot_1.PotKind.MAIN;
                this.pot = pot;
            }
        }
    }
    addPot(pot) {
        const exists = this.getAllPots().find((existingPot) => JSON.stringify(existingPot.getPlayerIds()) ===
            JSON.stringify(pot.getPlayerIds()));
        if (pot.kind === Pot_1.PotKind.MAIN) {
            this.pot.amount += pot.amount;
        }
        else {
            if (exists) {
                exists.amount += pot.amount;
            }
            else {
                if (this.pot.amount === 0) {
                    pot.kind = Pot_1.PotKind.MAIN;
                    this.pot = pot;
                }
                else {
                    pot.kind = Pot_1.PotKind.SIDE;
                    this.sidePots.unshift(pot);
                    this.event$.next(BoardEvent_1.BoardEvents.createSidePot(this));
                }
            }
        }
    }
    everyoneFolded() {
        const countOfWinningHands = [this.pot, ...this.sidePots].reduce((winners, pot) => {
            const winningHands = pot.winners.filter((winner) => winner.winningCards === null);
            if (winningHands) {
                winners = winners.concat(...winningHands);
                return winners;
            }
        }, []);
        if (countOfWinningHands.length === 0) {
            return true;
        }
        return false;
    }
    clearBets() {
        this.bets = [];
    }
    getTotalPotsValue() {
        return (this.pot.amount +
            this.sidePots.reduce((acc, pot) => {
                acc += pot.amount;
                return acc;
            }, 0));
    }
    getBetsTotal() {
        return this.bets
            .filter((b) => b !== null && typeof b !== 'undefined')
            .reduce((acc, value) => {
            return acc + value.amount;
        }, 0);
    }
    getAllPots() {
        return [this.pot, ...this.sidePots].filter((b) => b !== null && typeof b !== 'undefined');
    }
    getBets() {
        return this.bets;
    }
    setBets(bets) {
        this.bets = bets;
    }
    internalState() {
        return this.state.tag;
    }
}
__decorate([
    class_transformer_1.Type(() => Deck_1.Deck),
    __metadata("design:type", Deck_1.Deck)
], Board.prototype, "deck", void 0);
__decorate([
    class_transformer_1.Type(() => String),
    __metadata("design:type", Array)
], Board.prototype, "communityCards", void 0);
__decorate([
    class_transformer_1.Type(() => Bet_1.Bet),
    __metadata("design:type", Array)
], Board.prototype, "bets", void 0);
__decorate([
    class_transformer_1.Type(() => Blind_1.Blind),
    __metadata("design:type", Blind_1.Blind)
], Board.prototype, "blinds", void 0);
__decorate([
    class_transformer_1.Type(() => Pot_1.Pot),
    __metadata("design:type", Pot_1.Pot)
], Board.prototype, "pot", void 0);
__decorate([
    class_transformer_1.Type(() => Pot_1.Pot),
    __metadata("design:type", Array)
], Board.prototype, "sidePots", void 0);
__decorate([
    class_transformer_1.Type(() => BoardState_1.BoardStates),
    __metadata("design:type", Object)
], Board.prototype, "state", void 0);
__decorate([
    class_transformer_1.Type(() => rxjs_1.Subject),
    __metadata("design:type", Object)
], Board.prototype, "event$", void 0);
exports.Board = Board;
//# sourceMappingURL=Board.js.map